import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const Styles = StyleSheet.create({
  pill: {
    backgroundColor: Colors.v2.backgroundGrayLight,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Colors.v2.gray50_15,
    borderRadius: grid(0.5),
    height: 'auto',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    margin: 4,
    flexShrink: 0,
    flexGrow: 0,
    paddingHorizontal: grid(0),
    paddingVertical: grid(0.25),
  },
  oneLine: {
    // @ts-ignore
    wordBreak: 'break-all',
  },
  round: {
    paddingHorizontal: grid(0.5),
    borderRadius: grid(2),
  },
  noBorder: {
    borderWidth: 0,
    paddingHorizontal: grid(0),
  },
  noLeftMargin: {
    marginLeft: 0,
  },
  noRightMargin: {
    marginRight: 0,
  },
  pillSection: {
    height: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexShrink: 1,
    alignItems: 'center',
    paddingVertical: grid(0.25),
    paddingHorizontal: grid(1),
    flexDirection: 'row',
  },
  notFirstSection: {
    borderLeftWidth: 1,
    borderStyle: 'solid',
    borderLeftColor: Colors.v2.gray10,
  },
  italic: {
    // prevents cutting off italic ascenders
    paddingRight: grid(0.25),
    fontStyle: 'italic',
  },
  preventWrap: {
    // @ts-ignore
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  sectionHasRemove: {
    paddingRight: 0,
  },
  remove: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    justifyContent: 'center',
    paddingHorizontal: grid(0.5),
    // @ts-ignore
    cursor: 'pointer',
  },
  disabled: {
    opacity: 0.5,
  },
  loading: {
    paddingVertical: grid(0.25),
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
